// extracted by mini-css-extract-plugin
export default {"wrapperPartners":"Partners_wrapperPartners__3HjnP","partners":"Partners_partners__ZC0RM","slideWrapper":"Partners_slideWrapper__BXZuZ"};